// extracted by mini-css-extract-plugin
export default {"liveLabelContainer":"yDUCFT","titleWrapper":"au9Pah","publisherWrapper":"Zoj1a6","publisher":"QzuKsB"};